export default "/marketplace/listings/:seoListingId([0-9]{5,})";